/* Small UI motion with the Web Animations API (no animation library). There is no reveal-on-scroll: blocks that
   faded in one by one as they reached the window made the page feel uneven, so content is simply there. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ease = 'cubic-bezier(.2, .7, .2, 1)';
  const animate = (element, from, duration = 450) => {
    if (!element || reduce.matches || typeof element.animate !== 'function') return;
    element.animate([{ transform: `translateY(${from.y}px)`, opacity: from.opacity }, { transform: 'none', opacity: 1 }], { duration, easing: ease });
  };
  window.HumblerMotion = {
    scrollTo(element, left) {
      element?.scrollTo({ left, behavior: reduce.matches ? 'instant' : 'smooth' });
    }
  };
  // The bag count gives a small bump when the bag changes.
  document.addEventListener('humbler:cart:updated', () => {
    for (const badge of document.querySelectorAll('[data-preview-cart-count], .hb-header__count')) animate(badge, { y: -4, opacity: .5 }, 200);
  });
})();
